import { render, staticRenderFns } from "./GroupName.vue?vue&type=template&id=ceebf0fc&scoped=true"
import script from "./GroupName.vue?vue&type=script&lang=js"
export * from "./GroupName.vue?vue&type=script&lang=js"
import style0 from "./GroupName.vue?vue&type=style&index=0&id=ceebf0fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceebf0fc",
  null
  
)

export default component.exports